import type { FC } from 'react';
import { Modal } from '@carbon/react';
import styles from './rerun-agent-modal.module.scss';

interface RerunAgentModalProps {
  open: boolean;
  /** Permit / well label shown in the confirmation copy. */
  permitLabel: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// Confirmation for re-running the target-zone agent (replaces existing
// suggestions, so gated behind an explicit confirm).
export const RerunAgentModal: FC<RerunAgentModalProps> = ({
  open,
  permitLabel,
  loading,
  onClose,
  onConfirm,
}) => (
  <Modal
    open={open}
    modalHeading="Rerun Agent Suggestions"
    primaryButtonText={loading ? 'Rerunning…' : 'Rerun Agent Suggestions'}
    secondaryButtonText="Cancel"
    primaryButtonDisabled={loading}
    onRequestClose={onClose}
    onRequestSubmit={onConfirm}
  >
    <p className={styles.body}>
      This will rerun the target-zone agent for <strong>{permitLabel}</strong>.
      Existing suggestions will be replaced. Are you sure?
    </p>
  </Modal>
);
